import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Core,
  ConstructionCard,
  FieldGroup,
  Form,
  FormSection,
  FloatingLabelFormField,
  useContainerProps,
  Page,
} from '@everfi/reactifi';
import { useTranslation } from 'react-i18next';

export interface PreviousAccountInfo {
  username: string;
  password: string;
}

export interface TeacherSSOLinkProps {
  jwt: string;
  linkExistingProfile?: (jwt: string, data: PreviousAccountInfo) => {};
  skipSSOLink?: (jwt: string) => void;
}

const TeacherSSOLink: FC<TeacherSSOLinkProps> = props => {
  props = useContainerProps(props);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { linkExistingProfile, jwt, skipSSOLink } = props;

  const handleAccountLink = async (data: PreviousAccountInfo) => {
    if (linkExistingProfile) {
      const response = linkExistingProfile(jwt, data);
      if (response) {
        navigate('/teacher_registration/setup');
      }
    }
  };

  const handleSkip = async (jwt: string) => {
    if (skipSSOLink) {
      skipSSOLink(jwt);
    }
    navigate('/teacher_registration/setup');
  };

  return (
    <Page pageType="parent" contentType="cards" title={''} backButton={false} usePageWrapper={true}>
      <ConstructionCard
        title={t('Are you a previous EVERFI user?')}
        alwaysExpanded={true}
        data-object-id="sso-teacher-link-card"
      >
        <Core.Typography variant="p">
          {t(
            'If you already have an account in our system, you may import it into your new Clever-integrated account. Provide your other username and password below to connect your EVERFI accounts. If you are not a previous EVERFI user, you may skip this step.'
          )}
        </Core.Typography>
        <Form
          buttonGroupClass="modal-footer"
          cancelButtonText={t('Skip')}
          data={{}}
          onCancel={handleSkip}
          saveButtonText={t('Link Account')}
          addAction={handleAccountLink}
        >
          <FormSection>
            <FieldGroup>
              <FloatingLabelFormField name="username" caption={t('Previous Username')} />
            </FieldGroup>
            <FieldGroup>
              <FloatingLabelFormField
                validationType="password"
                name="password"
                type="password"
                caption={t('Previous Password')}
              />
            </FieldGroup>
          </FormSection>
        </Form>
      </ConstructionCard>
    </Page>
  );
};

export default TeacherSSOLink;
